import type { TOC } from '@ember/component/template-only'
import type { ColumnObject } from 'teacher-ui-client/components/stable-table/basic-table/cell'

interface SpannerSignature {
  Element: HTMLTableCellElement
  Args: {
    columns: ColumnObject[]
  }
  Blocks: { default: [] }
}

/**
 * Spanner component uses a tbody to span entire table width then yields the spanned element. This can be used as a
 * convenient way to display a centered loading or empty message within the table.
 *
 * Can be used adjacent to an existing basic table tbody component - it is valid HTML to have multiple tbody elements in
 * the same table.
 */
export const BasicTableSpanner: TOC<SpannerSignature> = <template>
  <tbody data-test-basic-table-spanner>
    <tr>
      <td colspan={{@columns.length}} ...attributes>
        {{yield}}
      </td>
    </tr>
  </tbody>
</template>

export default BasicTableSpanner
